import { useLocalSearchParams } from 'expo-router';
import { useQuery } from 'urql';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import Icon from '../Unistyles/Icon';

const GetEventGenerateHeader = graphql(/* GraphQL */ `
  query GetEventGenerateHeader($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      title
    }
  }
`);

export default function EventGenerateHeader() {
  const { eventId } = useLocalSearchParams<{
    eventId?: string;
  }>();

  const [{ data }] = useQuery({
    query: GetEventGenerateHeader,
    variables: {
      eventId: eventId!,
    },
  });

  return (
    <Box
      direction="horizontal"
      overflow="hidden"
      flex
      px="4xl"
      space="sm"
      align="center"
      justify="center"
    >
      <Icon name="trophy-outline" size="3xl" />
      <Text numberOfLines={1} size="xl" center>
        {data?.event_by_pk?.title}
      </Text>
    </Box>
  );
}
